import React, { Component, Children } from "react";

import { connect } from "react-redux";

import * as actions from "../../actions";

// VENDOR COMPONENTS
import FlatButton from "material-ui/FlatButton";
import RaisedButton from "material-ui/RaisedButton";
import Dialog from "material-ui/Dialog";

import { Form, Field } from "react-final-form";
import { FORM_ERROR } from "final-form";
import Select from "react-select";
import SelectField from "components/SelectField";

import Snackbar from "material-ui/Snackbar";
import ReactStars from "react-stars";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { withRouter } from "react-router-dom";

// Custom Components
import { TextFieldAdapter } from "../Form/TextFieldAdapter";
import TextAreaFieldAdapter from "../Form/TextAreaFieldAdapter";
import { FormIcon } from "../Form/FormIcon";
import AuthStepper from "../Stepper/AuthStepper";
import ScrollBodyDialog from "./ScrollBodyDialog";
import H2 from "components/Primatives/H2";
import FlexRow from "components/Primatives/FlexRow";
import TextButton from 'components/Button/TextButton';

// STAR RATING STYLES
import "react-star-rating/dist/css/react-star-rating.min.css";

// Utilities
import {
  required,
  isEmail,
  composeValidators,
  isNum,
  passwordsMustMatch
} from "../Form/validation";
import moment from "moment-timezone";
import { ActionButton } from "../Form/Buttons/ActionButton";
import { CancelButton } from "../Form/Buttons/CancelButton";
import { Radio, RadioGroup } from "react-radio-group";
import { constants } from "../../constants/index";
import FlexColumn from "components/Primatives/FlexColumn";
import Button from "components/Primatives/Button";
import StyledRouteLink from "components/Assests/StyledRouteLink";
import Link from "components/Primatives/Link";
import PText from "components/Primatives/PText";

let _submitting;
let _pristine;

const SelectFieldAdapter = ({ input, meta, ...rest }) => (
  <div>
    <SelectField
      {...input}
      {...rest}
      searchable
      // value={ this.state.selectSupportType }
      // onChange={this.handleSupportTypeChange}
    />
    <span
      style={{
        color: "red"
      }}
    >
      
      {meta.touched ? meta.error : ""}
    </span>
  </div>
);

class ConfirmEndCall extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {
        code: "",
        message: ""
      },
      finalStep: null,
      snackAutoHideDuration: 4000,
      snackMessage: "",
      snackOpen: false,
      stepToShow: 0,
      reasonForEndCall: "complete",
      shouldShowNotCompletedReasonSelection: false
      // rating: 5
    };
  }

  componentDidMount() {
    const { userData } = this.props;
    // console.log('CONSULT SERVICE', this.props.consultService._id, this.props.userData.uid);
    // REMOVE BELLOW IF STATEMENT WHEN ADDING CONSUMER SERVICE RATINGS
    if (userData && !userData.provider) {
      this.props.closeConfirmEndCallDialog();
    }
    if (
      this.props.consultService &&
      this.props.consultService._id &&
      this.props.userData.uid
    ) {
      this.props.getServiceRatingForUser({
        serviceId: this.props.consultService._id,
        clientUid: this.props.userData.uid
      });
      this.props.getServiceReviewForUser({
        serviceId: this.props.consultService._id,
        clientUid: this.props.userData.uid
      });
    }
  }

  handleConsultCompletion = () => {
    this.props.handleNoPromptOnNav();
    this.props.markConsultSessionAsComplete(
      this.props.sessionData,
      this.props.user
    )
    .then(() => {
      this.props.closeConfirmEndCallDialog();
      this.props.history.push(this.props.endCallNavigationLocation);
      this.props.updateLocation(this.props.endCallNavigationLocation);
    });

    // ADD A FALG TO THE BOOKING SAYING `sessionCompletionStatus: 'markedAsCompletedAwaitingProcessing'` AND CRON JOB WILL SEND EMAILS AT END OF DAY AND CHANGE FLAG TO 'markedAsCompletedProcessedSuccessfully
    // TODO: SEND END CALL FLAG TO BOOKING IN TO DATABASE - PERSON WILL BE BILLED AKA EMAIL SENT TO CLINIC TO BILL THEM AT THE END OF SERVICE
    // HOW DO I DETECT WHEN THE SERVICE IS EXPIRED AND THEN SEND AN EMAIL - END OF DAY CRON JOB TO HANLD ALLBILLING THAT WE DO NOT HANDLE

  };

  handleCloseConfirmEndCallDialog = () => {
    this.setState({
      shouldShowNotCompletedReasonSelection: false
    });
    this.props.closeConfirmEndCallDialog();
  };

  getCancelButton = (handleClose, reset) => {
    return (
        <TextButton 
            style={{
                position: 'absolute', 
                right: 0, 
                top: 15
            }} 
            onClick={(event)=>{
              this.handleCloseConfirmEndCallDialog();
            }}
        >
            <FormIcon 
                name="times" 
                size={20} 
                iconStyle='far' 
                style={{color: '#C3C3C3'}}
            />
        </TextButton>
    );
  }

  onSubmit = values => {
    // TODO: show spinners upon submit
    console.log("VALUES", values);
    if (values.rating) {
      this.props.saveServiceRating({
        rating: values.rating,
        serviceId: this.props.consultService._id,
        clientUid: this.props.userData.uid
      });
    }

    if (values.review) {
      this.props.saveServiceReview({
        review: values.review,
        serviceId: this.props.consultService._id,
        clientUid: this.props.userData.uid
      });
    }

    if (values.endSessionReason && values.endSessionReason.value) {
      this.props
        .saveEndConsultSessionReason({
          formData: values.endSessionReason.value,
          formDataType: "reasonOnly",
          sessionData: this.props.sessionData,
          user: this.props.user
        })
        .then(() => {
          this.props.closeConfirmEndCallDialog();
          this.props.history.push(this.props.endCallNavigationLocation);
          this.props.updateLocation(this.props.endCallNavigationLocation);
        });
    }

    if (values.otherReasonDetails) {
      this.props
        .saveEndConsultSessionReason({
          formData: values.otherReasonDetails,
          formDataType: "otherDetails",
          sessionData: this.props.sessionData,
          user: this.props.user
        })
        .then(() => {
          this.props.closeConfirmEndCallDialog();
          this.props.history.push(this.props.endCallNavigationLocation);
          this.props.updateLocation(this.props.endCallNavigationLocation);
        });
    } else if (values.otherTechnicalDetails) {
      this.props
        .saveEndConsultSessionReason({
          formData: values.otherReasonDetails,
          formDataType: "technicalDetails",
          sessionData: this.props.sessionData,
          user: this.props.user
        })
        .then(() => {
          this.props.closeConfirmEndCallDialog();
          this.props.history.push(this.props.endCallNavigationLocation);
          this.props.updateLocation(this.props.endCallNavigationLocation);
        });
    }
  };

  advanceStepper = () => {
    // console.log('Prev Step:', this.state.stepToShow);
    const currentStep = this.state.stepToShow;
    this.setState(
      {
        stepToShow: currentStep + 1
      },
      () => {
        // console.log('New Step:', this.state.stepToShow);
      }
    );
  };

  reverseStepper = () => {
    const currentStep = this.state.stepToShow;
    if (currentStep > 0) {
      this.setState({
        stepToShow: currentStep - 1
      });
    }
  };

  resetStepper = () => {
    this.setState({
      stepToShow: 0
    });
  };

  stepperControls = {
    advanceStepper: this.advanceStepper,
    reverseStepper: this.reverseStepper,
    setFinalStep: this.setFinalStep
  };

  handleCloseDialog = () => {
    this.props.handleClose();
  };

  setFinalStep = finalStep => {
    this.setState({
      finalStep: finalStep
    });
  };

  handleReasonSelect = event => {
    // console.log('TEST', reason);
    console.log("EVENT", event);

    this.setState(
      {
        reasonForEndCall: event
      },
      () => {
        console.log("STATE", this.state.reasonForEndCall);
      }
    );
  };

  renderProviderEndCallSurvey = () => (
    /* old stuff that shows steps we should follow
                 <div label="TEST">
             Please select an option then choose "end call"
             <p>1. This client consult has been completed as planned.</p>
             <p>2. The client did not show up to call</p>
             <p>3. There were technical problems preventing the call from continuing.</p>
             <p>4. Other: ________________________</p>
             <div style={{ marginTop: 30 }}>
                 <ActionButton 
                     options={{
                         label: "End Call",
                         backgroundColor: "darkred",
                         labelColor: "white",
                     }}
                     
                     userId={this.props.userId}
                     advanceStepper={this.advanceStepper}
                 />
                 <CancelButton 
                     handleClose={ this.handleCloseDialog }
                     customAction={ this.props.rejoinCall }
                     label="BACK TO CONSULT"
                 />
             </div>
         </div> 
         */

    <FlexColumn
      center
      label="TEST"
      style={{
        paddingTop: 30
      }}
    >
      {this.getCancelButton()}
      
      {!this.state.shouldShowNotCompletedReasonSelection && (
        <React.Fragment>
          <PText
            style={{
              marginTop: 5,
              marginBottom: 25
            }}
          >
            
            Would you like to mark this session as completed ?
          </PText>
          <FlexRow>
            <Button style={{margin: 10}} onClick={() => {this.handleConsultCompletion()}}>Yes</Button>         
            <Button
              style={{margin: 10}}
              onClick={() => {
                this.setState({
                  shouldShowNotCompletedReasonSelection: true
                });
              }}
            >
              No
            </Button>
          </FlexRow>
          {/* <PText>(The client will be charged)</PText> */}
          {/* <PText style={{marginTop: 5, marginBottom: 25}}>The client will be charged.</PText> */}
          <div
            style={{
              marginTop: 30
            }}
          >
            
            {/* <CancelButton 
                handleClose={ this.handleCloseDialog }
                customAction={ this.props.rejoinCall }
                label="BACK TO CONSULT"
            /> */}
            {/* <Link>Call Not completed</Link> */}
          </div>
        </React.Fragment>
      )}
      {this.state.shouldShowNotCompletedReasonSelection && (
        <React.Fragment>
          
          {/* <PText style={{marginTop: 5, marginBottom: 25}}>Please select the reason why the consult session could not be completed.</PText> */}
          <H2
            style={{
              marginTop: -30
            }}
          >
            
            Didn 't complete the session?
          </H2>
          <PText
            style={{
              marginTop: -30
            }}
          >
            
            (clients are only billed for completed sessions)
          </PText>
          <Form
            onSubmit={this.onSubmit}
            // initialValues={{ stooge: 'larry' }}

            render={({
              handleSubmit,
              reset,
              submitting,
              pristine,
              invalid,
              values,
              errors,
              meta
            }) => (
              <form
                onSubmit={e => {
                  this.props.handleNoPromptOnNav();
                  handleSubmit(e);
                  reset();
                }}
                style={{
                  width: "80%"
                }}
              >
                <div id="SelectFieldContainer" style={styles.formFieldStyles}>
                  <div style={styles.formFieldStyles}>
                    <label> Please tell us why ? </label>
                    <Field
                      // style={{ width: }}
                      name="endSessionReason"
                      component={SelectFieldAdapter}
                      options={[
                        {
                          value: "returning",
                          label: "I'm coming back later."
                        },
                        {
                          value: "noShow",
                          label: "The client did not arrive."
                        },
                        {
                          value: "technical",
                          label: "There was a technical problem."
                        },
                        {
                          value: "other",
                          label: "Other"
                        }
                      ]}
                      validate={value => {
                        return value ? undefined : "Required";
                      }}
                    />
                  </div>
                  {values.endSessionReason &&
                    values.endSessionReason.value === "technical" && (
                      <div style={styles.formFieldStyles}>
                        <label>
                          
                          Any feedback on your call would be greatly
                          appreciated(optional).
                        </label>
                        <Field
                          style={{ ...styles.inputStyles, height: 200 }}
                          name="technicalReasonDetails"
                          component={TextAreaFieldAdapter}
                          placeholder="Please, describe the problem with as much detail as you can, thanks!"
                        />
                      </div>
                    )}
                  {values.endSessionReason &&
                    values.endSessionReason.value === "other" && (
                      <div style={styles.formFieldStyles}>
                        <label> Details(optional) </label>
                        <Field
                          style={{ ...styles.inputStyles, height: 200 }}
                          name="otherReasonDetails"
                          component={TextAreaFieldAdapter}
                          placeholder="Optionally, you can describe why the session ended without completion for your records."
                        />
                      </div>
                    )}
                  {/* {<p>{JSON.stringify(values)}</p>} */}
                </div>
                <Button
                  onClick={() => {
                    this.setState({
                      shouldShowNotCompletedReasonSelection: true
                    });
                    // DONT SEND CALL COMPLETION TO DATABASE
                    // OR SELECT REASON FOR END CALL
                    // submit reason for incoplete booking to database
                  }}
                  style={{
                    width: "100%",
                    flex: 1
                  }}
                  disabled={submitting || pristine || invalid}
                  type="submit"
                >
                  {" "}Submit{" "}
                </Button>
                {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
              </form>
            )}
          />
        </React.Fragment>
      )}
    </FlexColumn>
  );
  handleRatingChange = rating => {
    console.log("RATING", rating);
    this.setState({
      rating
    });
    // this.props.saveProviderRating({ providerUid: providerId, clientUid: userData.uid, rating });
  };

  renderClientEndCallSurvey = () => {
    let invalidForm;
    return (
      <div label="Leave a Review">
        <h2>
          
          {this.props.serviceRating || this.props.serviceReview
            ? "ANYTHING TO ADD?"
            : "GOT FEEDBACK?"}
        </h2>
        {/* <h3>Thanks for using Cyno! Please consider leaving us some feedback so we can make Cyno even better.</h3> 
                                  <p style={{ marginTop: -15 }}>You can share your valuable feedback about this service below. </p> */}
        <Form
          onSubmit={this.onSubmit}
          initialValues={{
            review: this.props.serviceReview,
            rating: this.props.serviceRating
          }}
          render={({
            handleSubmit,
            reset,
            submitting,
            pristine,
            invalid,
            values,
            errors,
            meta
          }) => (
            <form
              id="serviceFeedbackForm"
              onSubmit={e => {
                this.props.handleNoPromptOnNav();
                handleSubmit(e);
                reset();
              }}
            >
              <div className="TextAreaContainer" style={styles.formFieldStyles}>
                <label
                  style={{
                    marginBottom: 10
                  }}
                >
                  
                  {this.props.serviceReview
                    ? "Has anything changed regarding your service experience?"
                    : "How would you describe your experience with this service?"}
                </label>
                <Field
                  className="TextAreaField"
                  style={{ ...styles.inputStyles, height: 200 }}
                  // value={this.props.serviceRating}
                  name="review"
                  component={TextAreaFieldAdapter}
                  placeholder="Please leave a brief description of you service experience."
                />
              </div>
              <label>
                
                {this.props.serviceRating
                  ? "Would you like to modify your rating?"
                  : "How would you rate this service?"}
              </label>
              <div style={styles.formFieldStyles}>
                <Field
                  style={{ ...styles.inputStyles, height: 200 }}
                  name="rating"
                  component={ReactStarsAdapter}
                  serviceRating={this.props.serviceRating || this.state.rating}
                  handleRatingChange={this.handleRatingChange}
                />
              </div>
              {/* <pre>{JSON.stringify(values, 0, 2)}{this.props.serviceRating}{this.props.serviceReview}</pre> */}
              <div
                style={{
                  marginTop: 30
                }}
              >
                
                {/* <button 
                                                          style={{ ...styles.buttonStyles, backgroundColor: constants.color.primary}} 
                                                          type="submit"
                                                          id="submit"
                                                          disabled={submitting}
                                                      >
                                                          { }
                                                      </button> */}
                <ActionButton
                  options={{
                    label:
                      pristine || invalid ? "MAYBE LATER" : "SEND FEEDBACK",
                    backgroundColor: constants.color.primary,
                    labelColor: "white",
                    form: "serviceFeedbackForm",
                    isForm: true,

                    disabled: submitting,
                    action: event => {
                      handleSubmit(event);
                      this.handleCloseDialog();
                      reset();
                    }
                  }}
                  userId={this.props.userId}
                  advanceStepper={this.handleCloseDialog}
                />
                <CancelButton
                  handleClose={this.handleCloseDialog}
                  customAction={this.props.rejoinCall}
                  label="BACK TO CONSULT"
                />
              </div>
            </form>
          )}
        />
      </div>
    );
  };

  render() {
    const { title, handleClose, open, user, userData } = this.props;

    return (
      <div
        onClick={() => {
          this.setState({
            dropDownOpen: false
          });
        }}
      >
        
        {
          <Dialog
            title={title}
            modal={true}
            open={open}
            autoScrollBodyContent={true}
            repositionOnUpdate={false}
            bodyStyle={{
              overflow: "visible"
            }}
            contentStyle={{
              overflow: "visible"
            }}
          >
            <div
              style={{
                marginTop: -10,
                marginBottom: 10
              }}
            >
              
              {!userData.provider && this.renderClientEndCallSurvey()}
              {userData.provider && this.renderProviderEndCallSurvey()}
            </div>
          </Dialog>
        }
      </div>
    );
  }
}

const mapStateToProps = ({ auth, dialog, client, service, video }) => {
  return {
    userData: client.clientData,
    user: auth.authData,
    userId: auth.authData ? auth.authData.id : null,
    serviceRating: service.userRating,
    serviceReview: service.userReview,
    sessionData: video.session,
    endCallNavigationLocation: video.endCallNavigationLocation,
  };
};

const ReactStarsAdapter = (
  { input, meta, ...rest },
  value,
  serviceRating,
  handleRatingChange,
  name
) => (
  <div
    style={{
      display: "flex"
    }}
  >
    <ReactStars
      count={5}
      onChange={handleRatingChange}
      size={24}
      color2={"#ffd700"}
      {...input}
      {...rest}
    />
    <span>{JSON.stringify(...input, ...rest)}</span>
  </div>
);

const styles = {
  // buttonStyles: {
  //     padding: 10,
  //     backgroundColor: constants.color.primary,
  //     borderRadius: 5,
  //     borderWidth: 0,
  //     fontSize: 14,
  //     fontFamily: 'Open Sans',
  //     marginRight: 15,
  //     color: 'white',
  // },
  inputStyles: {
    width: "100%",
    padding: 10,
    fontSize: 14,
    borderRadius: 5,
    borderColor: "transparent",
    borderWidth: 0,
    backgroundColor: "rgba(220,220,220, 0.6)",
    fontFamily: "Open Sans"
  },
  formFieldStyles: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    marginBottom: 15
  },
  radioStyles: {
    cursor: "pointer",
    justifyContent: "flex-start",
    color: "black"
  }
};

export default withRouter(
  connect(
    mapStateToProps,
    actions
  )(ConfirmEndCall)
);

/*
   
 title
 altActionText
 mainActionText
 open 
 handleClose
   
 */



// WEBPACK FOOTER //
// ./src/js/components/Dialog/ConfirmEndCall.jsx